import { IAM_CONTRACT, NON_CONTRACT, STATUS_CANCEL_SUBMITTED, STATUS_SUBMITTED, TWU_CONTRACT, WORKGROUP_MANAGER } from "./constants";

export const TRADE_SUBMISSION_CUTOFF_TIME_REMINDER = {
  [IAM_CONTRACT]: {
    warningContent: {
      header: "IAM CUTOFF TIME REMINDER:",
      message:
        "Trades and cancellations submitted after 2000 the day prior to the day of the first intended trade may be approved if time permits.",
    },
  },
  [TWU_CONTRACT]: {
    warningContent: {
      header: "TWU CUTOFF TIME REMINDER:",
      message:
        "Trades and cancellations submitted less than eight (8) hours prior to the starting time of the first intended trade will be subject to Management approval.",
    },
  },
  [NON_CONTRACT]: {
    warningContent: {
      header: "CUTOFF TIME REMINDER:",
      message:
        "Trades and cancellations submitted after 2000 the day prior to the day of the first intended trade will be subject to Manager approval.",
    },
  },
};

export const getEligibleEmployeeLabel = (employee) => {
  let employeeLabel = employee.FullName + " (" + employee.PersonNumber + ") - " + employee.Workgroup;
  return employeeLabel;
};

export const getTradeWorkgroups = (allWorkgroups) => {
  const tradeWorkgroups = allWorkgroups.filter((workgroup) => workgroup !== WORKGROUP_MANAGER);
  return tradeWorkgroups;
};

export const isAdminActionRequired = (status) => {
  return status === STATUS_SUBMITTED || status === STATUS_CANCEL_SUBMITTED;
}